import { render, staticRenderFns } from "./MongoDataTableFooter.vue?vue&type=template&id=06156891&scoped=true&"
import script from "./MongoDataTableFooter.vue?vue&type=script&lang=js&"
export * from "./MongoDataTableFooter.vue?vue&type=script&lang=js&"
import style0 from "./MongoDataTableFooter.vue?vue&type=style&index=0&id=06156891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06156891",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VFlex,VLayout,VPagination,VSelect})
